class chartFeed extends HTMLElement {
  constructor() {
    super();
    this.chartContext = this.querySelector("#feedChart")
    this.data = this.querySelector("#feed-data");
  }

  connectedCallback() {
    // Wait for next tick to ensure Chart.js is fully loaded
    setTimeout(() => {
      if (!window.Chart) {
        console.error("Chart.js not loaded");
        return;
      }
      this.renderChart();
    }, 0);
  }

  renderChart() {
    const Chart = window.Chart;
    if (!this.chartContext) {
      console.error("Feed chart canvas not found");
      return;
    }

    if (!this.data) {
      console.error("Feed data not found");
      return;
    }

    const feeds = JSON.parse(this.data.textContent);

    // Process data by feed type
    const wombarooData = [];
    const vytrateData = [];
    const labels = [];
    feeds.forEach((feed) => {
      const date = new Date(feed.fed_at).toLocaleString();

      const value = parseFloat(feed.value);
      if (feed.feed_type?.toLowerCase() === "wombaroo" || feed.feed_product_brand?.toLowerCase() === "wombaroo") {
        wombarooData.push({
          x: date,
          y: value,
        });
      }
      else if (feed.feed_type?.toLowerCase() === "vytrate" || feed.feed_product_brand?.toLowerCase() === "vytrate") {
        vytrateData.push({
          x: date,
          y: value,
        });
      }

      // Collect unique dates for labels
      if (!labels.includes(date)) {
        labels.push(date);
      }
    }
    );

    // Sort labels chronologically
    labels.sort((a, b) => new Date(a) - new Date(b));
    const ctx = this.chartContext.getContext("2d");
    new Chart(ctx, {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Wombaroo (ml)",
            data: wombarooData,
            borderColor: "rgb(75, 192, 192)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            tension: 0.1,
            fill: false,
          },
          {
            label: "Vytrate (ml)",
            data: vytrateData,
            borderColor: "rgb(255, 99, 132)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            tension: 0.1,
            fill: false,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: "Feed Volume Over Time",
          },
          legend: {
            display: true,
            position: "top",
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Volume (ml)",
            },
          },
          x: {
            title: {
              display: true,
              text: "Date",
            },
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
    });
  }
}

customElements.define("chart-feed", chartFeed);